import { type RefObject } from "react";
import type { Map as MapboxMap } from "mapbox-gl";
import { FINANCE_VIEW_TABS, type FinanceView } from "@/constants";
import TabList from "../TabList";
import FinanceTokensView from "./FinanceTokensView";
import FinancePlacesView from "./FinancePlacesView";
import { useNavigate, useParams } from "react-router-dom";
import type { TileEnv } from "@/env";

interface FinanceProps {
    map: RefObject<MapboxMap | undefined>;
    env: TileEnv;
}

function Finance(props: FinanceProps) {
    const { view = "tokens" } = useParams<{ view: FinanceView }>();
    const navigate = useNavigate();

    return (
        <>
            <TabList
                tabs={FINANCE_VIEW_TABS}
                current={view}
                setCurrent={(v) => navigate(`/finance/${v}`)}
            />
            {view === "tokens" && <FinanceTokensView map={props.map} env={props.env} />}
            {view === "places" && <FinancePlacesView map={props.map} env={props.env} />}
        </>
    );
}

export default Finance;
